export default [
  {
    path: "/vendas",
    component: () =>
      import(/* webpackChunkName: "vendas" */ "../views/Venda/Index.vue"),
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        component: () =>
          import(
            /* webpackChunkName: "lista-analise" */ "../views/Venda/Lista.vue"
          ),
      },
      {
        path: "produtos",
        name: "Produtos",
        component: () =>
          import(
            /* webpackChunkName: "produtos" */ "../views/Venda/Produtos.vue"
          ),
      },
      {
        path: "checkout",
        name: "NovaVenda",
        component: () =>
          import(/* webpackChunkName: "produtos" */ "../views/Venda/Criar.vue"),
      },

      // ⚠️ ROTA ESTÁTICA ANTES DA DINÂMICA
      {
        path: "link-cielo",
        name: "VendaLinkCielo",
        component: () =>
          import(
            /* webpackChunkName: "venda-link-cielo" */
            "../views/Venda/VendaLinkCielo.vue" // <- caminho conforme você informou (pasta "venda" minúscula)
          ),
        props: (route) => ({ idVenda: route.query.idVenda }),
      },

      {
        path: "editar/:id",
        name: "Editar venda",
        component: () =>
          import(
            /* webpackChunkName: "editar-venda" */ "../views/Venda/Editar.vue"
          ),
        props: true,
      },
      {
        path: ":id",
        name: "Visualizar venda",
        component: () =>
          import(
            /* webpackChunkName: "analise-venda" */ "../views/Venda/Visualizar.vue"
          ),
      },
    ],
  },
];
